import React from "react";
import { Dropdown, DropdownMenu, DropdownItem, Button } from "reactstrap";

import { getMessage } from "CONFIG/i18n";
import "../../App/App.less";
import "../../../Components/Header/Header.less";
import "./AddUserDropdown.less"
import { userAction } from "CONFIG/ActionFactory";

class AddUserDropdown extends React.Component {
  downloadUsersCsv(customerId) {
    let requestBodyData = { 
      customerId
    }
    userAction.getAllUsersAction(requestBodyData, true).then(
      response => {
        const fileText = new Blob([response.data], { type: "text/csv" });
        const textFile = window.URL.createObjectURL(fileText);
        const downloadElement = document.createElement("a");
        downloadElement.href = textFile;
        downloadElement.download = "users.csv";
        downloadElement.click();
      },
      error => {
      }
    );
  }

  render() {
    return (
      <Dropdown 
        className="addUserDropdown"
        direction="down"
        isOpen={this.props.show}
        toggle={this.props.toggleAddUserDropdown}
      >
        <DropdownMenu className="addUserDropdownMenu p-0">

          <DropdownItem className="addUserDropdownOption" onClick={this.props.showAddUserModal}>
            <label className="addUserDropdownMenuItem">
              {getMessage("ADD_USER")}
            </label>
          </DropdownItem>

          <DropdownItem divider className="m-0"/>

          <DropdownItem className="addUserDropdownOption"
            onClick={this.props.showBulkImportUserModal}>
            <label className="addUserDropdownMenuItem">
              {getMessage("BULK_IMPORT")}
            </label>
          </DropdownItem>

          <DropdownItem divider className="m-0"/>

          <DropdownItem className="addUserDropdownOption"
            onClick={() => this.downloadUsersCsv(this.props.customerId)}>
            <label className="addUserDropdownMenuItem">
              {getMessage("USERS_LIST_DOWNLOAD")}
            </label>
          </DropdownItem>

        </DropdownMenu>
      </Dropdown>
    );
  }
}
export default AddUserDropdown;